<script>
  import GamesList from '@/views/app/dashboard/challenge-friends/components/GamesList.vue';
  import StakeSelection from '@/views/app/dashboard/challenge-friends/components/StakeSelection.vue';
  import PrivateRoom from '@/views/app/dashboard/battleground/components/PrivateRoom.vue';
  import { GameLauncher } from '@/mixins/game-launcher';
  import { gameInfos } from '@/data/games';
  import { BANK_IDS } from '@/store';

  export default {
    name: 'ChallengeFriends',

    components: {
      PrivateRoom,
      StakeSelection,
      GamesList,
      PalmIcon: async () => await import('@/assets/images/svg/icons/palm.svg'),
      AchievementIcon: async () => await import('@/assets/images/svg/icons/achievement.svg'),
      DefeatIcon: async () => await import('@/assets/images/svg/icons/defeat.svg'),
      AimIcon: async () => await import('@/assets/images/svg/icons/aim.svg'),
      StrikeIcon: async () => await import('@/assets/images/svg/icons/strike.svg'),
      FragmentsIcon: async () => await import('@/assets/images/svg/icons/fragments.svg'),
      UseIcon: async () => await import('@/assets/images/svg/icons/use.svg'),
      ReceiveIcon: async () => await import('@/assets/images/svg/icons/receive.svg'),
      TakeDownIcon: async () => await import('@/assets/images/svg/icons/take-down.svg'),
      CriticalIcon: async () => await import('@/assets/images/svg/icons/critical.svg'),
      CubeIcon: async () => await import('@/assets/images/svg/icons/cube.svg'),
      SpecialWeaponIcon: async () => await import('@/assets/images/svg/icons/special-weapon.svg'),
    },

    mixins: [GameLauncher],

    data: () => ({
      selectedGame: {
        imageURL: '/images/cards/games/SX.png',
        alias: 'SECTOR_X',
        title: 'Sector X',
        id: 867,
        comingSoon: false,
        gameIdFF: '866',
        route: 'sector-x',
        bullets: gameInfos['sector-x'].pvp,
      },
      selectedQCStake: {
        value: 200000,
        name: 'RUMBLE',
        description: 'Prepare to challenge your friends with 2K QC',
        text: '2K QC',
        img: '/images/cards/challenge-friends/rumble.png',
      },
      selectedMCStake: {
        value: 100,
        name: 'RUMBLE',
        description: 'Prepare to challenge your friends with 1 MC',
        text: '1 MC',
        img: '/images/cards/challenge-friends/rumble.png',
      },
      loading: false,

      gameDialog: false,
      buyInDialog: false,

      newGames: [
        {
          imageURL: '/images/cards/games/SX.png',
          alias: 'SECTOR_X',
          title: 'Sector X',
          id: 867,
          gameIdFF: '866',
          route: 'sector-x',
          bullets: gameInfos['sector-x'].pvp,
        },
        {
          imageURL: '/images/cards/games/DS.png',
          title: 'DragonStone',
          alias: 'DRAGON_STONE',
          id: 856,
          gameIdFF: '838',
          route: 'dragonstone',
          bullets: gameInfos['dragonstone'].pvp,
        },
        {
          imageURL: '/images/cards/games/MA.png',
          title: 'Mission Amazon',
          id: 862,
          gameIdFF: '859',
          route: 'mission-amazon',
          bullets: gameInfos['mission-amazon'].pvp,
        },
        {
          imageURL: '/images/cards/games/mbc.jpg',
          title: 'MaxBlast Champs',
          id: 864,
          redirect: 'maxblast',
          bullets: gameInfos['maxblast'].pvp,
        },
        {
          imageURL: '/images/cards/games/multiplinko.jpg',
          title: 'Multiplinko',
          id: 1,
          unityGame: true,
          bullets: gameInfos['plinko'].pvp,
        },
        {
          imageURL: '/images/cards/games/MM.png',
          title: 'MultiMines',
          id: 6,
          unityGame: true,
          bullets: gameInfos['multi-mines'].pvp,
        },
        {
          imageURL: '/images/cards/games/roh.jpg',
          title: 'Roll Or Hold',
          id: 2,
          unityGame: true,
          bullets: gameInfos['roll-or-hold'].pvp,
        },
        {
          imageURL: '/images/cards/games/R21.png',
          title: 'Rolling 21',
          id: 5,
          unityGame: true,
          bullets: gameInfos['rolling-21'].pvp,
        },
      ],
      stakesMC: [
        {
          value: 100,
          name: 'RUMBLE',
          description: 'Prepare to challenge your friends with 1 MC',
          text: '1 MC',
          img: '/images/cards/challenge-friends/rumble.png',
        },
        {
          value: 200,
          name: 'FRENZY',
          description: 'Prepare to challenge your friends with 2 MC',
          text: '2 MC',
          img: '/images/cards/challenge-friends/frenzy.png',
        },
        {
          value: 500,
          name: 'RAGE',
          description: 'Prepare to challenge your friends with 5 MC',
          text: '5 MC',
          img: '/images/cards/challenge-friends/rage.png',
        },
        {
          value: 1000,
          name: 'FURY',
          description: 'Prepare to challenge your friends with 10 MC',
          text: '10 MC',
          img: '/images/cards/challenge-friends/fury.png',
        },
        {
          value: 2000,
          name: 'STORM',
          description: 'Prepare to challenge your friends with 20 MC',
          text: '20 MC',
          img: '/images/cards/challenge-friends/storm.png',
        },
        {
          value: 5000,
          name: 'CHAOS',
          description: 'Prepare to challenge your friends with 50 MC',
          text: '50 MC',
          img: '/images/cards/challenge-friends/chaos.png',
        },
      ],
      stakesQC: [
        {
          value: 200000,
          name: 'RUMBLE',
          description: 'Prepare to challenge your friends with 2K QC',
          text: '2K QC',
          img: '/images/cards/challenge-friends/rumble.png',
        },
        {
          value: 400000,
          name: 'FRENZY',
          description: 'Prepare to challenge your friends with 4K QC',
          text: '4K QC',
          img: '/images/cards/challenge-friends/frenzy.png',
        },
        {
          value: 1000000,
          name: 'RAGE',
          description: 'Prepare to challenge your friends with 10K QC',
          text: '10K QC',
          img: '/images/cards/challenge-friends/rage.png',
        },
        {
          value: 4000000,
          name: 'FURY',
          description: 'Prepare to challenge your friends with 40K QC',
          text: '40K QC',
          img: '/images/cards/challenge-friends/fury.png',
        },
        {
          value: 10000000,
          name: 'STORM',
          description: 'Prepare to challenge your friends with 100K QC',
          text: '100K QC',
          img: '/images/cards/challenge-friends/storm.png',
        },
        {
          value: 20000000,
          name: 'CHAOS',
          description: 'Prepare to challenge your friends with 200K QC',
          text: '200K QC',
          img: '/images/cards/challenge-friends/chaos.png',
        },
      ],
    }),

    computed: {
      QCMode() {
        return !(this.$store.getters.getPlayerMode && this.$store.getters.getPlayerMode === 'MMC');
      },
      newGamesCards() {
        let result = this.newGames;

        result = result.map((game) => ({
          ...game,
          disabled: !this.isGameAvailable(game.id),
          comingSoon: this.isGameComingSoon(game.id),
        }));
        result = result.sort((a, b) => a.comingSoon - b.comingSoon);

        return result.filter((game) => !game.disabled);
      },
    },

    created() {
      this.$store.dispatch('getCurrentUserID');
    },

    mounted() {
      this.$root.$on('enterPrivateRoom', (privateRoomId) => {
        const addFriendUrl = process.env.VUE_APP_ADD_FRIEND_URL;
        this.enterPrivateRoom(privateRoomId, 'CAF', addFriendUrl);
      });
    },

    methods: {
      isGameAvailable(gameId) {
        if (this.$store.getters.getActiveGames.length > 0) {
          const game = this.$store.getters.getActiveGames.find((game) => game.key === String(gameId));
          return game ? game.active : false;
        } else {
          return false;
        }
      },
      isGameComingSoon(gameId) {
        if (this.$store.getters.getActiveGames.length > 0) {
          const game = this.$store.getters.getActiveGames.find((game) => game.key === String(gameId));
          return game ? game.comingSoon : false;
        } else {
          return false;
        }
      },
      toggleGameDialog(flag) {
        this.gameDialog = flag;
      },
      toggleBuyinsDialog(flag) {
        this.buyInDialog = flag;
      },
      selectGame(game, toggleDialog) {
        if (game.comingSoon) {
          this.$store.dispatch('showAlertDialog', {
            title: 'Coming Soon',
            text: 'This game is coming soon! Stay tuned for further updates.',
          });
          return;
        }
        this.selectedGame = game;
        toggleDialog(false);
      },
      selectQCStake(stake, toggleDialog) {
        this.selectedQCStake = stake;
        toggleDialog(false);
      },
      selectMCStake(stake, toggleDialog) {
        this.selectedMCStake = stake;
        toggleDialog(false);
      },
      checkCoin(stake, toggleDialog) {
        if (this.QCMode) {
          this.selectQCStake(stake, toggleDialog);
        } else {
          this.selectMCStake(stake, toggleDialog);
        }
      },
      async launchGameIfReady() {
        if (this.$store.getters.getAcceptedFriendsList.length === 0 && !this.selectedGame.unityGame) {
          return await this.$store.dispatch('showAlertDialog', {
            title: 'Add friends',
            text: 'To continue, please first add friends.',
            permanent: true,
          });
        }

        if (this.selectedGame && ((this.QCMode && this.selectedQCStake) || (!this.QCMode && this.selectedMCStake))) {
          await this.openPrivateRoom();
        } else {
          await this.$store.dispatch('showAlertDialog', {
            title: 'Challenge not sent',
            text: 'To continue, please pick your game and room.',
          });
        }
      },
      async openPrivateRoom() {
        if (!this.checkUserBalance()) {
          return;
        }

        if (this.selectedGame.unityGame) {
          const buyIn = this.QCMode ? this.selectedQCStake.value : this.selectedMCStake.value;
          const hostId = this.$store.getters.getCurrentUserID;
          const addFriendUrl = process.env.VUE_APP_ADD_FRIEND_URL;
          this.launchGameUnity(this.selectedGame.id, 'MLTP', addFriendUrl, 'extended', buyIn, true, hostId);
        } else {
          await this.$store.dispatch('requestGameplayTokenAs');
          let token = this.$store.getters.getGameplayToken;

          let selectedGameData = {
            gameId: this.selectedGame.id,
            bankId: this.QCMode ? BANK_IDS.MQC : BANK_IDS.MMC,
            buyIn: this.QCMode ? this.selectedQCStake.value : this.selectedMCStake.value,
            privateRoomToken: token,
          };

          let returnData = await this.$store.dispatch('getPrivateRoomID', selectedGameData);

          if (returnData.privateRoomId) {
            await this.$store.dispatch('requestGameplayTokenAs');
            token = this.$store.getters.getGameplayToken;
            const addFriendUrl = process.env.VUE_APP_ADD_FRIEND_URL;

            let privateRoomData = {
              selectedFriends: [],
              token,
              privateRoomDbData: returnData.privateRoomDbData,
              addFriendUrl,
            };

            await this.$store.dispatch('issueChallenge', privateRoomData);

            const privateRoomURL = this.$store.getters.getPrivateRoomURL;

            if (privateRoomURL !== undefined) {
              await this.$store.dispatch('showIFrameDialog', {
                url: privateRoomURL,
                callback: () => {
                  this.closeModal();
                },
              });
            }
          } else {
            await this.$store.dispatch('showAlertDialog', {
              title: 'Challenge not sent',
              text: returnData.message || 'Error creating private room',
            });
          }
        }
      },
      closeModal() {
        this.$emit('update:selectedPriceIndex', 0);

        this.$store.dispatch('showConfirmDialog', {
          title: 'Exiting game',
          text: 'Are you sure you want to close the game?',
          callback: () => {
            this.$store.dispatch('hideIFrameDialog');
          },
        });
      },
    },
  };
</script>

<template>
  <div class="caf-container">
    <v-row>
      <v-col class="d-flex align-center flex-column" cols="12">
        <v-img class="mt-n15" max-width="450px" src="/images/logos/caf.webp?v=1" />
        <span class="text-h6 font-weight-800 mt-n10">Ready to prove your skills?</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <div class="px-5">
          <v-btn block class="caf-select-btn" @click="() => toggleGameDialog(true)">
            <v-icon left>mdi-menu</v-icon>
            <span class="text-h6 font-weight-800">Game: {{ selectedGame.title }}</span>
          </v-btn>

          <div class="caf-selection d-flex mt-5">
            <v-img
              :src="selectedGame.imageURL"
              class="game-image"
              contain
              height="100%"
              max-width="150px"
              width="100%"
            />
            <div class="d-flex flex-column ml-5 w-full my-auto">
              <div v-for="bullet of selectedGame.bullets" :key="bullet.text" class="my-1 my-sm-2 d-flex align-center">
                <component :is="`${bullet.svgIcon}Icon`" class="bullet-icon mt-1" />
                <span class="white--text text-caption text-sm-subtitle-2 text-left ml-2" v-html="bullet.text" />
              </div>
            </div>
          </div>
        </div>
      </v-col>

      <v-col cols="12" md="6">
        <div class="mx-5">
          <v-btn block class="caf-select-btn" @click="() => toggleBuyinsDialog(true)">
            <v-icon left>mdi-menu</v-icon>
            <span class="text-h6 font-weight-800">
              Buy In: {{ QCMode ? selectedQCStake.text : selectedMCStake.text }}
            </span>
          </v-btn>

          <div class="caf-selection d-flex mt-5">
            <v-img
              :src="QCMode ? selectedQCStake.img : selectedMCStake.img"
              class="game-preview"
              contain
              height="100%"
              max-width="110px"
            >
              <span class="text-subtitle-2 text-sm-h6 font-weight-800 text-no-wrap text-shadow-1">
                {{ QCMode ? selectedQCStake.text : selectedMCStake.text }}
              </span>
            </v-img>
            <div class="d-flex flex-column ml-5">
              <span class="text-subtitle-1 font-weight-800 mt-3 mb-5">
                {{ QCMode ? selectedQCStake.name : selectedMCStake.name }}
              </span>
              <span class="text-subtitle-1">
                {{ QCMode ? selectedQCStake.description : selectedMCStake.description }}
              </span>
            </div>
          </div>
        </div>
      </v-col>

      <v-col class="d-flex justify-center pb-10" cols="12">
        <action-button>
          <template #action="{ loading, clickHandler }">
            <v-btn
              :loading="loading"
              class="caf-play-btn border-single text-capitalize white"
              @click="clickHandler(launchGameIfReady)"
            >
              Play Now
            </v-btn>
          </template>
        </action-button>
      </v-col>
    </v-row>

    <v-dialog
      v-model="buyInDialog"
      :transition="$vuetify.breakpoint.xs ? 'my-transition' : 'fade-transition'"
      fullscreen
    >
      <v-card class="caf-dialog-bg">
        <v-toolbar>
          <v-btn class="back-button text-capitalize align-center" @click="() => toggleBuyinsDialog(false)">
            <v-icon color="white">mdi-chevron-left</v-icon>
            <span class="text-h6 text-sm-h5 font-weight-800">
              Buy in /
              {{ QCMode ? selectedQCStake.text : selectedMCStake.text }}
            </span>
          </v-btn>
        </v-toolbar>

        <v-row class="buyins-grid">
          <div v-for="buyin in QCMode ? stakesQC : stakesMC" :key="buyin.text" class="d-flex w-full justify-center">
            <v-img
              :src="buyin.img"
              class="buyin cursor-pointer"
              contain
              max-width="150px"
              @click="checkCoin(buyin, toggleBuyinsDialog)"
            >
              <span class="buyins-grid-text white--text font-weight-800 text-no-wrap text-shadow-1">
                {{ buyin.text }}
              </span>
            </v-img>
          </div>
        </v-row>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="gameDialog"
      :transition="$vuetify.breakpoint.xs ? 'my-transition' : 'fade-transition'"
      fullscreen
    >
      <v-card class="caf-dialog-bg">
        <v-toolbar>
          <v-btn class="back-button text-capitalize align-center" @click="() => toggleGameDialog(false)">
            <v-icon color="white">mdi-chevron-left</v-icon>
            <span class="text-h6 text-sm-h5 font-weight-800">Games / {{ selectedGame.title }}</span>
          </v-btn>
        </v-toolbar>

        <v-row class="items-grid">
          <v-col v-for="(game, index) in newGamesCards" :key="index" cols="12" lg="4" md="6">
            <div
              v-is-game-active="game.id"
              class="caf-selection cursor-pointer d-flex flex-row mt-5"
              @click="() => selectGame(game, toggleGameDialog)"
            >
              <v-img
                :src="game.imageURL"
                class="game-image golden-hover"
                contain
                height="100%"
                max-height="150px"
                max-width="150px"
                width="100%"
              >
                <img
                  v-if="game.comingSoon"
                  v-reload-on-fail
                  alt="coming-soon"
                  class="card-coming-soon"
                  src="/images/icons/coming-soon-big.png"
                />
              </v-img>
              <div class="d-flex flex-column ml-5 my-auto">
                <div v-for="bullet of game.bullets" :key="bullet.text" class="my-1 my-sm-3 d-flex align-center">
                  <component :is="`${bullet.svgIcon}Icon`" class="bullet-icon mt-1" />
                  <span class="white--text text-caption text-sm-subtitle-2 text-left ml-2" v-html="bullet.text" />
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="scss" scoped>
  .v-dialog__content {
    z-index: 204 !important;
  }

  .card-coming-soon {
    position: absolute;
    max-width: 150px;
    top: -40px;
    z-index: 4;

    @media screen and (max-width: 600px) {
      top: -20px;
      max-width: 100px;
    }
  }

  .caf-container {
    max-width: 1080px;
    margin: 0 auto;

    @media screen and (max-width: 960px) {
      max-width: 800px !important;
    }
  }

  .caf-selection .bullet-icon {
    width: 16px;
    height: 16px;
  }

  .caf-dialog-bg {
    background: linear-gradient(180deg, rgba(74, 47, 112, 1) 0%, rgba(111, 91, 155, 1) 71%);

    .items-grid {
      max-width: 1300px;
      margin: 0 auto !important;
      padding-bottom: 100px;

      @media screen and (max-width: 600px) {
        //max-width: 320px;
      }
    }

    .buyins-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      max-width: 600px;
      margin: 40px auto !important;
      padding-bottom: 60px;
      align-items: center;
      gap: 40px;

      @media screen and (max-width: 600px) {
        max-width: 350px;
        grid-template-columns: repeat(2, 1fr);
      }

      .buyin {
        &:hover {
          box-shadow: 0 0 14px 0 var(--v-gold-base);
        }
      }

      .v-responsive__content {
        position: relative;

        span {
          position: absolute;
          left: 50%;
          top: 40%;
          transform: translate(-50%, -50%);
        }
      }

      &-text {
        font-size: 27px;
        margin-top: 10px;
      }
    }
  }

  .v-toolbar::v-deep {
    background-color: #24073d !important;
    color: white;

    .back-button {
      background-color: transparent;
      box-shadow: none;

      .v-icon {
        font-size: 35px;
      }
    }
  }

  .caf-play-btn {
    &::v-deep {
      span {
        color: black !important;
      }
    }

    @media screen and (max-width: 600px) {
      margin-bottom: 70px !important;
    }
  }

  .caf-selection {
    width: 100%;
    height: 100%;
    padding: 20px;
    background-color: #5e4476;
    border-radius: 10px;
    min-height: 120px;

    @media screen and (max-width: 400px) {
      padding: 10px !important;
    }

    .game-image {
      margin: auto 0;
      border-radius: 8px !important;

      @media screen and (max-width: 600px) {
        max-width: 100px !important;
        max-height: 100px !important;
      }
    }

    &:hover {
      .golden-hover {
        box-shadow: 0 0 14px 0 var(--v-gold-base);
      }
    }

    .game-preview::v-deep {
      @media screen and (max-width: 600px) {
        max-width: 74px !important;
      }

      .v-responsive__content {
        position: relative;

        span {
          position: absolute;
          left: 50%;
          top: 45%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }

  .caf-select-btn::v-deep {
    background-color: transparent !important;
    color: white;
    border-bottom: 1px solid white;
    box-shadow: none;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;

    .v-btn__content {
      justify-content: flex-start;
      text-transform: none;
      font-size: 20px;
      font-weight: 600;
      align-items: baseline;
    }
  }

  .divider {
    background-image: url('/images/divider.png');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    height: 40px;
    width: 100%;
    margin: 30px 0;

    @media screen and (max-width: 600px) {
      background-image: url('/images/figures/Divider.png');
    }
  }

  .actions-container {
    @media screen and (max-width: 600px) {
      flex-direction: column;
      gap: 40px;

      &::v-deep .border-doubled.gold.large {
        margin: 0 !important;
        width: 200px !important;
      }
    }
  }
</style>
